import React, { useEffect, useState } from 'react';
import { oneKlicks } from '../../SDK/oneclick';

const CornJob = () => {

    const [cornJob, setCornJob] = useState([]);

    useEffect(() => {
        fetchCornJob();
    }, []);

    const fetchCornJob = async () => {
        try {
            const tableSchema = '';
            const tableName = 'corn_jobs';
            const conditions = {};
            const orderBy = 'id DESC';
            const search = {};
            const pagination = {};
            const margedata = [];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("corn job response :", response);
            if (response.success && response.data.length > 0) {
                setCornJob(response.data);
            } else {
                setCornJob([]);
            }
        } catch (error) {
            console.error("Error fetching corn job :", error);
            setCornJob([]);
        }
    };

    // cornJob data table under more urls that i need run as per time basis
    const cornJobData = cornJob.map((item) => {
        return {
            id: item.id,
            url: item.url,
            time: item.time,
        }
    });

    useEffect(() => {
        const runCornJob = async () => {
            cornJobData.forEach(async (item) => {
                const response = await fetch(item.url);
                console.log("response :", response);
            });
        }
        runCornJob();
    }, [cornJobData]);


    return (
        <div>
            <h1>Corn Job</h1>
        </div>
    );
};

export default CornJob;
